"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  "use strict";

  iotService.$inject = ["$http", "$q", "appConfig", "settingsService"];
  angular.module("app.services").factory("iotService", iotService);

  /* @ngInject */
  function iotService($http, $q, appConfig, settingsService) {
    var service = {
      getCategories: getCategories,
      getModalities: getModalities,
      getSensors: getSensors,
      getDevices: getDevices,
      getFois: getFois,
      getFoisOnline: getFoisOnline,

      getParkingDevices: getParkingDevices,
      getParkingDevicesStatus: getParkingDevicesStatus,
      getParkingDevicesWithStatus: getParkingDevicesWithStatus,

      getDevice: getDevice,
      getDeviceGateway: getDeviceGateway,

      getInfrastructure: getInfrastructure,

      getGateways: getGateways,
      getGateway: getGateway,

      getDevicesWithStatus: getDevicesWithStatus,
      getDeviceWithStatus: getDeviceWithStatus,

      filterModalitiesByIds: filterModalitiesByIds,
      filterFoisByModalityIds: filterFoisByModalityIds,
      filteredDevicesFromFoisByModalityIds: filteredDevicesFromFoisByModalityIds
    };

    return service;

    function inArrayFilter(attribute, values) {
      var object = {};

      object[attribute] = _.partial(_.includes, values);

      return _.conforms(object);
    }

    function hasIntersectionFilter(attribute, values) {
      var object = {};
      object[attribute] = function (o) {
        return _.intersection(o, values).length > 0;
      };

      return _.conforms(object);
    }

    ////////////////

    /**
     * Returns the modality categories
     */
    function getCategories() {
      return $q.when([{
        id: 1,
        slug: "urban-environment",
        name: "Urban environment",
        name_el: "Αστικό περιβάλλον",
        modality_ids: [4, // Temperature
        11, // Humidity
        13, // Atmospheric pressure
        14, // Wind Speed
        1, // Ambient light
        6, // Sulphur dioxide
        12, // Carbon dioxide
        10, // Dust
        7, // Ozone
        5, // VOC
        8, // Nitrogen dioxide
        9, // Nitrogen oxide
        2, // Loudness
        3, // Rainfall
        26]
      }, {
        id: 2,
        slug: "water-resources",
        name: "Water resources",
        name_el: "Υδάτινο περιβάλλον",
        modality_ids: [17, // Acidity
        18, // Temperature
        19, // Conductivity
        20, // Nitrate ions
        21, // Ammonium cations
        22, // Calcium cations
        23, // Chloriede anions
        24]
      }]);
    }

    function filterModalitiesByIds(modalities, modalityIds) {
      return _.filter(modalities, inArrayFilter("id", modalityIds));
    }

    function filterFoisByModalityIds(fois, modalityIds) {
      return _.filter(fois, hasIntersectionFilter("modality_ids", modalityIds));
    }

    function filteredDevicesFromFoisByModalityIds(fois, modalityIds) {
      return _(fois).filter(hasIntersectionFilter("modality_ids", modalityIds)).flatMap("devices").value();
    }

    /**
     * Returns the modalities
     */
    function getModalities() {
      var showHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var config = {
        params: {
          select: "*,sensor_modalities(sensor_id,min_measurement,max_measurement)"
        },
        cache: true
      };

      return $q.all({
        modalities: $http.get(appConfig.apiUrl + "/modalities", config).then(function (r) {
          return r.data;
        }),
        categories: getCategories(),
        iotConfig: showHidden || settingsService.getValue("Visualizer/iotConfig/exclude")
      }).then(function (r) {
        var _ref;

        var excludeList = _.get(r.iotConfig, "modalities", []),
            modalities = _.reject(r.modalities, inArrayFilter("id", excludeList)),
            categories = _.mapKeys(r.categories, "id");

        var categoryMappings = (_ref = _).assign.apply(_ref, _toConsumableArray(_.map(r.categories, function (o) {
          return _.zipObject(o.modality_ids, _.times(o.modality_ids.length, _.constant(o.id)));
        })));

        modalities.forEach(function (modality) {
          var sensors = _(modality.sensor_modalities);

          modality.category = categories[categoryMappings[modality.id]];
          modality.sensor_ids = sensors.map("sensor_id").value();
          modality.min_value = sensors.map("min_measurement").min();
          modality.max_value = sensors.map("max_measurement").max();
          delete modality.sensor_modalities;
        });

        return modalities;
      });
    }

    /**
     * Returns the sensors.
     */
    function getSensors() {
      var showHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var config = {
        params: { select: "*,sensor_modalities(*)" },
        cache: true
      };

      return $q.all({
        sensors: $http.get(appConfig.apiUrl + "/sensors", config).then(function (r) {
          return r.data;
        }),
        iotConfig: showHidden || settingsService.getValue("Visualizer/iotConfig/exclude")
      }).then(function (r) {
        var excludeList = _.get(r.iotConfig, "sensors", []);
        return _.reject(r.sensors, inArrayFilter("id", excludeList));
      });
    }

    /**
     * Returns the devices.
     */
    function getDevices() {
      var showHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var config = {
        params: {
          select: "*,sensors:sensors.device_sensors(id,sensor_modalities(modality_id))"
        },
        cache: true
      };

      return $q.all({
        devices: $http.get(appConfig.apiUrl + "/devices", config).then(function (r) {
          return r.data;
        }),
        iotConfig: showHidden || settingsService.getValue("Visualizer/iotConfig/exclude")
      }).then(function (r) {
        var excludeList = _.get(r.iotConfig, "devices", []),
            devices = _.reject(r.devices, inArrayFilter("id", excludeList));

        /** Get modalities for each devices */
        devices.forEach(function (device) {
          device.modality_ids = _(device.sensors).flatMap("sensor_modalities").map("modality_id").uniq().difference(_.get(r.iotConfig, "modalities", [])).value();
        });

        return devices;
      });
    }

    /**
     *
     * @param {*} id
     */
    function getDevice(id) {
      var config = {
        params: {
          select: "*,sensors:sensors.device_sensors(id,sensor_modalities(modality_id))",
          id: "eq." + id
        },
        cache: true
      };

      return $http.get(appConfig.apiUrl + "/devices", config).then(function (r) {
        var device = _.get(r.data, "0", undefined);

        if (!device) {
          throw "Device does not exist";
        }

        device.modality_ids = _(device.sensors).flatMap("sensor_modalities").map("modality_id").uniq().value();

        return device;
      });
    }

    /**
     * Returns the fois.
     */
    function getFois() {
      var showHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var config = {
        params: { select: "*,device_ids:devices(id)" },
        cache: true
      };

      return $q.all({
        fois: $http.get(appConfig.apiUrl + "/fois", config).then(function (r) {
          return r.data;
        }),
        iotConfig: settingsService.getValue("Visualizer/iotConfig/exclude")
      }).then(function (r) {
        var excludeList = _.get(r.iotConfig, "fois", []),
            fois = _.reject(r.fois, inArrayFilter("id", excludeList));

        fois.forEach(function (foi) {
          foi.device_ids = _.map(foi.device_ids, "id");
        });

        return fois;
      });
    }

    /**
     * Get the infrastructure
     */
    function getInfrastructure() {
      var showHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return $q.all({
        fois: getFois(showHidden),
        devices: getDevices(showHidden),
        modalities: getModalities(showHidden),
        categories: getCategories()
      }).then(function (rsp) {
        var fois = rsp.fois,
            devices = _(rsp.devices),
            modalities = _(rsp.modalities),
            categories = _(rsp.categories);

        fois.forEach(function (foi) {
          var foiDevices = devices.filter(inArrayFilter("id", foi.device_ids));

          foi.devices = foiDevices.value();
          foi.devices.forEach(function (device) {
            device.foi = foi;
          });

          foi.modality_ids = foiDevices.flatMap("modality_ids").uniq().value();
          foi.modalities = modalities.filter(inArrayFilter("id", foi.modality_ids)).value();

          foi.categories = categories.filter(hasIntersectionFilter("modalities", _.map(foi.modalities, "slug"))).value();
        });

        return fois;
      });
    }

    /**
     *
     * @param {*} type
     * @param {*} modalities
     */
    function getFoisOnline(type) {
      var showHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var views = {
        weather: "weather_online_devices",
        gasses: "gasses_online_devices",
        water: "water_online_devices",
        water_ions: "water_ions_online_devices"
      };

      return $q.all({
        fois: getInfrastructure(showHidden),
        online: $http.get(appConfig.apiUrl + "/" + views[type]).then(function (r) {
          return r.data;
        })
      }).then(function (r) {
        var online = _(r.online).map("device_id");
        return _.filter(r.fois, function (foi) {
          return online.intersection(foi.device_ids).value().length > 0;
        });
      });
    }

    /**
     *
     */
    function getWaterFoisOnline(type) {
      var showHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return $q.all({
        fois: getInfrastructure(showHidden),
        online: $http.get(appConfig.apiUrl + "/" + views[type]).then(function (r) {
          return r.data;
        })
      }).then(function (r) {
        var online = _(r.online).map("device_id");
        return _.filter(r.fois, function (foi) {
          return online.intersection(foi.device_ids).value().length > 0;
        });
      });
    }

    /**
     *
     * @param {*} id
     */
    function getGatewayDevices() {
      var gatewayId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var deviceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var config = { params: {}, cache: true };

      if (gatewayId) {
        config.params["gateway_id"] = "eq." + gatewayId;
      }

      if (deviceId) {
        config.params["device_id"] = "eq." + deviceId;
      }

      return $http.get(appConfig.apiUrl + "/gateway_devices", config).then(function (r) {
        return r.data;
      });
    }

    /**
     *
     */
    function getGateways() {
      var withDevices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return $q.all({
        gateways: $http.get(appConfig.apiUrl + "/gateways", { cache: true }).then(function (r) {
          return r.data;
        }),
        statuses: $http.get(appConfig.apiUrl + "/gateways_status").then(function (r) {
          return r.data;
        }),
        devices: withDevices ? getDevicesWithStatus() : [],
        gatewayDevices: withDevices ? getGatewayDevices() : []
      }).then(function (r) {
        var gateways = r.gateways,
            statuses = _.keyBy(r.statuses, "gateway_id"),
            gatewayDevices = _.groupBy(r.gatewayDevices, "gateway_id");

        gateways.forEach(function (o) {
          o.online = _.get(statuses, o.id + ".status", "") === "online" ? true : false;
          o.since = _.get(statuses, o.id + ".since", "");

          if (withDevices) {
            o.devices = _.filter(r.devices, inArrayFilter("id", _.map(gatewayDevices[o.id], "device_id")));
            o.devices.forEach(function (device) {
              device.gateway = o;
            });
          }
        });

        return gateways;
      });
    }

    /**
     *
     * @param {*} id
     */
    function getGateway(id) {
      var withDevices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return $q.all({
        gateway: $http.get(appConfig.apiUrl + "/gateways", {
          params: { id: "eq." + id },
          cache: true
        }),
        status: $http.get(appConfig.apiUrl + "/gateways_status", {
          params: { gateway_id: "eq." + id }
        }),
        devices: withDevices ? getDevicesWithStatus() : [],
        gatewayDevices: withDevices ? getGatewayDevices(id) : []
      }).then(function (r) {
        var gateway = _.get(r.gateway.data, "0", false),
            gatewayDevices = _.groupBy(r.gatewayDevices, "gateway_id");

        gateway.online = _.get(r.status.data, "0.status", "") === "online" ? true : false;
        gateway.since = _.get(r.status.data, "0.since", "");

        if (withDevices) {
          gateway.devices = _.filter(r.devices, inArrayFilter("id", _.map(gatewayDevices[gateway.id], "device_id")));
        }

        return gateway;
      });
    }

    function getDeviceGateway(id) {
      return getGatewayDevices(null, id).then(function (r) {
        var gatewayId = _.get(r, "0.gateway_id", -1);
        return getGateway(gatewayId, false);
      });
    }

    /**
     *
     */
    function getDevicesWithStatus() {
      var showHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return $q.all({
        devices: getDevices(showHidden),
        statuses: $http.get(appConfig.apiUrl + "/devices_status", {
          cache: false
        })
      }).then(function (r) {
        var devices = r.devices,
            statuses = _.keyBy(r.statuses.data, "device_id");

        devices.forEach(function (o) {
          o.online = _.get(statuses, o.id + ".status", "") === "online" ? true : false;
          o.since = _.get(statuses, o.id + ".since", "");
        });

        return devices;
      });
    }

    /**
     *
     * @param {*} id
     */
    function getDeviceWithStatus(id) {
      var config = { params: { device_id: "eq." + id }, cache: true };

      return $q.all({
        device: getDevice(id),
        status: $http.get(appConfig.apiUrl + "/devices_status", config).then(function (r) {
          return r.data;
        })
      }).then(function (r) {
        var device = r.device;

        device.online = _.get(r.status, "0.status", "") === "online" ? true : false;
        device.since = _.get(r.status, "0.since", "");

        return device;
      });
    }

    /**
     *
     */
    function getParkingDevices() {
      return $q.all({
        modalities: getModalities(),
        devices: getDevices()
      }).then(function (r) {
        var parking = _.find(r.modalities, { slug: "parking" });

        return _.filter(r.devices, function (o) {
          return _.intersection(_.map(o.sensors, "id"), parking.sensor_ids).length > 0;
        });
      });
    }

    function getParkingDevicesStatus() {
      return $http.get(appConfig.apiUrl + "/parking_online_devices").then(function (r) {
        return r.data;
      });
    }

    /**
     *
     */
    function getParkingDevicesWithStatus() {
      return $q.all({
        devices: getParkingDevices(),
        statuses: $http.get(appConfig.apiUrl + "/parking_status").then(function (r) {
          return r.data;
        })
      }).then(function (r) {
        var devices = r.devices,
            statuses = _.keyBy(r.statuses, "device_id");
        var statusesMap = {
          true: "occupied",
          false: "free",
          undefined: "offline"
        };

        devices.forEach(function (o) {
          _.assign(o, _.get(statuses, "" + o.id, {}));
          o.status = statusesMap[o.presence];
          o.lat = o.latitude;
          o.lng = o.longitude;
        });

        return devices;
      });
    }
  }
})();